<script setup lang="ts">
import { useCvButtonNavigation } from './useCvButtonNavigation';
import NuxtLinkFlat from 'theme/components/atoms/NuxtLinkFlat.vue';

const { cvButtonTo } = useCvButtonNavigation();
</script>

<template>
  <div :class="$style.container">
    <p :class="$style.container__title">
      <slot name="title" />
    </p>
    <slot name="img" />
    <p :class="$style.container__personality"><slot name="personality" /></p>
    <p :class="$style.container__body"><slot name="body" /></p>
    <NuxtLinkFlat variant="primary" size="large" :to="cvButtonTo"
      >自分も診断してみる</NuxtLinkFlat
    >
  </div>
</template>

<style module lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  max-width: 480px;
  gap: 24px;
  &__title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }
  &__personality {
    font-size: 14px;
    font-weight: 600;
  }
  &__body {
    text-align: center;
  }
}
</style>
